import Vue from 'vue'
import Vuex from 'vuex'
import projects from '../../data/projects.json'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        projects,
        projectsFilter: 'All',
    },
    getters: {
        projectsFilter: ({ projectsFilter }) => projectsFilter,
        getProjectById: ({ projects }) => {
            return id => projects.find(project => project.id === id)
        },
        filteredProjects: ({ projects, projectsFilter }) => {
            if (projectsFilter === 'All') {
                return projects
            }
            return projects.filter(
                project =>
                    Object.values(project.stack)
                        .flat()
                        .join(' ')
                        .indexOf(projectsFilter) !== -1
            )
        },
    },
    mutations: {
        setProjectsFilter(state, { filter }) {
            state.projectsFilter = filter
        },
    },
    actions: {
        filterProjects({ commit }, filter) {
            commit({
                type: 'setProjectsFilter',
                filter,
            })
        },
    },
    modules: {},
})
